export default "__VITE_ASSET__C7bVUzq3__"